export default __webpack_public_path__ + "static/media/steep-logo.8a84bb7a.png";